import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, PopoverController, App, ModalController, Img } from 'ionic-angular';
import { VisitorProvider } from '../../providers/visitor/visitor';
import { CreatePassPage } from '../create-pass/create-pass';
import { ToastProvider } from '../../providers/toast/toast';
import { PopoverPage } from '../popover/popover';
import { LoginProvider } from '../../providers/login/login';
import { PassPurposePage } from '../pass-purpose/pass-purpose';
import { SocialSharing } from '@ionic-native/social-sharing';
import { UtilService } from '../../services/util';
import { PassDetailPage } from '../pass-detail/pass-detail';
// import { SharePassPage } from '../share-pass/share-pass';
import { FacilitySelectLocationPage } from '../facility-select-location/facility-select-location'
import { TranslateService } from '@ngx-translate/core';
import { FacilityProvider } from '../../providers/facility/facility';
import { TemplateDetailsPage } from '../template-details/template-details'
import { PermissionCheckPipe } from '../../pipes/permission-check/permission-check';
import moment from 'moment';
import { environment } from '../../environments/environment';
import { Storage } from '@ionic/storage';




@IonicPage()
@Component({
  selector: 'page-pass',
  templateUrl: 'pass.html',
  providers: [PermissionCheckPipe]

})
export class PassPage {

  passes: any;
  fakepasses: Array<any> = new Array(1);
  permissions: any;
  userData;
  loginDetail;
  societySettings = {};
  selRegistrationLogin : any;
  locations : any
  URL_ISM = environment.ismUrl;
  loginDetails = {}

  constructor(private app: App,
    private translate: TranslateService,
    public navCtrl: NavController,
    private storage: Storage,
    public navParams: NavParams,
    private visitorProvider: VisitorProvider,
    private toast: ToastProvider,
    private popoverCtrl: PopoverController,
    private login: LoginProvider,
    private socialSharing: SocialSharing,
    private loginProvider: LoginProvider,
    private util: UtilService,
    private modalCtrl: ModalController,
    private facilityProvider : FacilityProvider,
    private perPipe: PermissionCheckPipe) {
      this.selRegistrationLogin = localStorage.getItem('signup_login')

      this.storage.get("loginDetails").then(val => {
        this.loginDetails['societyId'] = val.societyId;
        this.loginDetails['id'] = val.id;
      })

      if(this.selRegistrationLogin){
        this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.") 
        this.passes = [{purpose: 'cab',mobile:'7011XXXXXX' , pass_no :'xyz Pass No.',date_time : '2020-12-11 16:15:25',demo :"This is for Demo Purpose Only"}]
              }
              else{

    visitorProvider.getPass("").then(val => {
      this.passes = val.data;
      this.getParkingDetails('ANY')
    });
    this.getLocation()

    login.profileDetails().then(val => {
      if (val) {
        this.userData = val;
        login.getUserDetails().then(val => {
          this.loginDetail = val;
        });
        console.log(val);
      }
    });

    login.getUserDetails().then(val => {
      this.permissions = val.permissions;
    });

    this.loginProvider.getSocietySettings().then(val => {
      this.societySettings = val;
    });
  }
  }
  
  doRefresh(refresher) {
    if(this.selRegistrationLogin){
      setTimeout(() => {
        refresher.complete() 
        console.log("yes refreshare timeout complete")
        },2000)
    }else{
    this.visitorProvider.getPass("").then(val => {
      this.passes = val.data;
      this.getParkingDetails('ANY')
      refresher.complete();
    });
  }
  }

  refresh() {
    this.passes = null;
    this.visitorProvider.getPass("").then(val => {
      this.passes = val.data;
      this.getParkingDetails('ANY')
    });
  }

  deletePass(pass: any) {
    this.visitorProvider.deletePass(pass).then(val => {
      if (val.status == "success") {
        this.removeByAttr(this.passes, "id", pass.id);
        this.toast.presentToast("Pass Deleted");
      } else {
        this.toast.presentToast(val.message);
      }
    });
  }

  removeByAttr(arr, attr, value) {
    var i = arr.length;
    while (i--) {
      if (arr[i]
        && arr[i].hasOwnProperty(attr)
        && (arguments.length > 2 && arr[i][attr] === value)) {
        this.passes.splice(i, 1);
      }
    }
  }

  createPass() {
    let modal = this.modalCtrl.create(PassPurposePage);
    modal.present();
    // this.app.getRootNav().push(PassPurposePage,{
    //   parentPage: this
    // });
  }

  sharePass(pass){
    if(this.selRegistrationLogin){
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.") 
    }else{
    let msg="";
    if(pass.purpose=="guest"){
      msg = `Dear ${pass.name}`;
    }
    else{
      msg = `Dear Visitor`;
    }
    let name = (this.loginDetail.tenant == true && this.userData.tenant == 1) ? this.userData.alt_name :  this.userData.name;
    msg +=`,\n\n*${name}* has invited you to Unit: *${this.loginDetail.flat_no}* at ${this.loginDetail.society_name}`;
    if(!pass.valid_days || pass.valid_days == ''){
      let dateTxt = this.util.getShortDate(pass.date_time);
      msg = msg + ` on ${dateTxt}.`;
    }else{
      msg +='.';
    }if(pass.pass_no){
      msg += `\n\n*${pass.pass_no}* is your pass code for entry. \n\n_Show this pass code at society gate for your entry._`; 
    }
    // share location with msg 
    if(this.societySettings['society_data'].data){
      const objectarr = JSON.parse(this.societySettings['society_data'].data);
      // console.log(objectarr.location_link);
      if(objectarr.location_link==null){
        msg +="";
      }
      else{
        msg += `\n\nLocation: ${objectarr.location_link}`;
      }
    }
  
    if(pass.parking_details){
      msg += `\n\n*${pass.parking_details.data.vehicle_no}* | *${moment(pass.parking_details.booking_from).format('"MMM Do, hh:mm a"')} - ${moment(pass.parking_details.booking_to).format('"MMM Do, hh:mm a"')}*  is your Parking  details . \n\nClick to below link: \n\n${this.URL_ISM}/my/parking/receipt/${this.loginDetails['societyId']}/${this.loginDetails['id']}/${pass.parking_details.id}/1`
    }
     
    msg += `\n\n_iSocietymanager_`;  
    console.log(msg);

    this.socialSharing.share(msg,null,null,null).then(() => {
      console.log("sharing done");
    }).catch(() => {
      this.toast.presentToast("Unable to share!");
    });

    // this.login.getUserDetails().then(val => {
    //   this.app.getRootNav().push(SharePassPage,{
    //     passDetails: pass,
    //     userDetails: val,
    //     msg
    //   });
    // });
  }
  }

  editPass(pass: any) {
    if (pass.valid_days && pass.valid_days != "[]") {
      this.app.getRootNav().push(CreatePassPage, {
        parentPage: this,
        passDetails: pass
      });
    } else {
      this.toast.presentToast("only recurring passes are editable");
    }
  }

  showPass(pass: any) {
    // this.app.getRootNav().push(CreatePassPage,{
    //   passDetails: pass,
    //   showPass: true
    // });
    this.app.getRootNav().push(PassDetailPage, {
      passDetails: pass
    });
  }

  presentPopover(myEvent, item) {

    var optionData = [ 
    {
      title: this.translate.instant("EDIT"),
      handler: function (that) {
        that.editPass(item);
      }
    }
   
  ]

  if((this.perPipe.transform(this.permissions, 'GSTPRK', 'READ'))){
    optionData.push( {
      title: 'Book Parking',
      handler: function (that) {
        that.goToAmenityPage(item);
      }
    })
  }
  if((this.perPipe.transform(this.permissions, 'VMSPAS', 'DELETE'))){
    optionData.push( {
      title: this.translate.instant("DELETE"),
      handler: function (that) {
        that.deletePass(item);
      }
    })
  }

    let popover = this.popoverCtrl.create(PopoverPage, {
      parentPage: this,
      options:optionData
    });
    popover.present({
      ev: myEvent
    });
  }


  goToAmenityPage(data:any){
    this.app.getRootNav().push(FacilitySelectLocationPage,{
  name:data.name,
  mobile:data.mobile,
  type:'PARKING',
  pass_id:data.id
})
  }

  getLocation(){
    this.facilityProvider.getLocations('').then(val => {
      if(val.status == "success"){
        this.locations = val.data;
      }
    });
  }

  getParkingDetails(id) {
    this.facilityProvider.getParkingDetails(id).then(val => {
      if (val.data && val.status == 'success'){
        var parkingData = val.data
        this.passes.forEach(pass => {
        parkingData.forEach(val =>{
          if(val.reference_id && pass.id == val.reference_id){
               pass.parking_details = val
          }
        })
        })
      }
      console.log(this.passes,"final pass")
    })
  }

  goToParkingPassPage(item){
    this.locations.forEach(loc =>{
      if(loc.id == item.parking_details.location_id){
       item.parking_details.location = loc
       this.app.getRootNav().push(TemplateDetailsPage,{
        data:item.parking_details,
        type:'PARKING_RECEIPT_FORMAT'
      })
      }
    })
   
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PassPage');
  }
  
}


// WEBPACK FOOTER //
// ./src/pages/pass/pass.ts